import { A, CdnIcon, Span, StatusBanner } from '@pcln/horizon'

import useSeti from '@/hooks/useSeti'

const EXPERIMENT_CODE = 'PKG_SEARCH_IN_PATH_ERROR_PHONE_CTA'
const PHONE_CTA_HEADING = "Having trouble? We're here."
const PHONE_CTA_CAPTION = 'Our travel experts are standing by to help you complete your trip.'
const PHONE_DISPLAY = '1 (877) 477-5807'
const PHONE_HREF = 'tel:+18774775807'

export default function GenericErrorBanner() {
  const showPhoneCta = useSeti({ experimentCode: EXPERIMENT_CODE }) === 'VARIANT'

  return (
    <div className='flex flex-col gap-3'>
      <StatusBanner
        headingNode={
          <Span textStyle='body2' bold>
            Uh oh! Something went wrong with your search.{' '}
            <Span style={{ fontWeight: 'normal' }}>Please try again.</Span>
          </Span>
        }
        palette='caution'
        iconNode={<CdnIcon iconName='error' />}
      />
      {showPhoneCta && (
        <StatusBanner
          headingNode={
            <Span textStyle='body2' bold>
              {PHONE_CTA_HEADING}
            </Span>
          }
          captionNode={PHONE_CTA_CAPTION}
          palette='neutral'
          emphasis='regular'
          iconNode={<CdnIcon iconName='call' />}
          primaryCtaNode={
            <A href={PHONE_HREF} size='sm'>
              {PHONE_DISPLAY}
            </A>
          }
        />
      )}
    </div>
  )
}
